import React from "react";
import "../styles/GoogleAuth.css";

function GoogleAuth({ next = "/", cameFrom = "login" }) {
    const startGoogle = () => {
        const backend = window.location.origin;

        // next should be a PATH like "/register_complete"
        const nextParam = encodeURIComponent(next);
        const cameFromParam = encodeURIComponent(cameFrom);

        window.location.href = `${backend}/auth/google/start?next=${nextParam}&cameFrom=${cameFromParam}`;
    };

    return (
        <button
            type="button"
            className="google-auth-btn"
            onClick={startGoogle}
        >
            <img
                src="/static/google-logo.png"
                alt="Google"
                className="google-auth-icon"
            />
            <span className="google-auth-label">
                Continue with Google
            </span>
        </button>
    );
}

export default GoogleAuth;
